<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-form ref="exemptionForm">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="exemptionData.dateFrom"
                :label="languageData.dateFrom"
                prepend-icon="mdi-calendar"
                readonly
                :rules="[
                    (v) => !!v
                ]"
                v-bind="attrs"
                v-on="on"
                outlined
                clearable
                :clear-icon-cb="clearText"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="exemptionData.dateFrom"
              no-title
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu = false"
            >
              {{ languageData.cancel }}
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.menu.save(exemptionData.dateFrom)"
            >
              {{ languageData.btnAgreeText }}
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="exemptionData.dateTo"
                :label="languageData.dateTo"
                prepend-icon="mdi-calendar"
                readonly
                :rules="[
                    (v) => !!v
                ]"
                v-bind="attrs"
                v-on="on"
                outlined
                clearable
                :clear-icon-cb="clearText"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="exemptionData.dateTo"
              no-title
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu2 = false"
            >
              {{ languageData.cancel }}
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.menu2.save(exemptionData.dateTo)"
            >
              {{ languageData.btnAgreeText }}
            </v-btn>
          </v-date-picker>
        </v-menu>
        <div class="d-flex justify-end">
          <v-btn
              class="mr-2"
              color="primary"
              outlined
              @click="cancelForm">
            {{ languageData.cancel }}
          </v-btn>
          <v-btn
              color="primary"
              :loading="isLoading"
              @click="acceptForm">
            {{ languageData.btnSaveText }}
          </v-btn>
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";

export default {
  name: "CompanyExemptionForm",
  data() {
    return {
      exemptionData: {
        dateFrom: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateTo: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      menu: false,
      menu2: false,
    }
  },
  computed: {
    ...mapState("setCompanyExemption", {
      isLoading: state => state.isLoading
    })
  },
  methods: {
    ...mapActions('setCompanyExemption', ['setExemption', 'updateVisibleExemptionFormModal']),
    acceptForm() {
      this.setExemption({creds: this.exemptionData});
    },
    cancelForm() {
      this.updateVisibleExemptionFormModal(false);
    },
    clearText() {
      this.$refs.exemptionForm.reset();
    }
  },
  mounted() {
    eventBus.$on("invoicePaidAtSuccess", () => {
      this.invoiceData.paidAt = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    })
  }
}
</script>

<style scoped>

</style>